/*! tmf-upsell.js — The Music Frontiers · upsell / cross-sell dùng chung `_cfg` (24/10/2026; 26/10 "same design" thật).
 * Không phụ thuộc theme: chỉ cần window.TMF (tmf-core.js) + 1 thư viện vật đã nạp (widget.lib).
 * Gồm:
 *   - crossCfg(): cùng thiết kế của khách (cùng layout + _cfg) → cốc / ly / ornament / canvas / sherpa / loa / ốp; chỉ đổi mực
 *     (hoặc Vintage → Classic cùng layout) khi chữ chính < 3:1 trên nền phôi; tileKey() chọn ảnh nền (cốc đen/trắng theo mực)
 *   - planFor() + drawTile(): vẽ SỐNG thiết kế lên ảnh nền phôi (ô "Same design, more gifts", thumbnail giỏ, email, thank you)
 *   - totals(): luật giỏ — free ship 2+ món (hoặc 1 món ≥ $59), giảm áo 2 −10% / 3 −15% / 4+ −20% (chỉ trên áo)
 *   - pickOffer(): ĐÚNG 1 lời mời trong drawer (ornament trước 7/12 → cốc; đã 2+ món → áo cho bạn cùng ban)
 *   - deliveryEstimate(), cleanNote(), profit()
 * Theme thật: luật giá/ship ở đây CHỈ để hiển thị; tiền thật do Shopify automatic discount tính (README "Upsell demo").
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.TMFUpsell = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var RULES = {
    shipFee: 4.95,            // ship khách trả khi chưa free
    freeShipMinItems: 2,      // FREE US shipping on 2+ items (add-on không tính)
    freeShipMinSubtotal: 59,  // hoặc 1 món ≥ $59 (sau giảm)
    apparelTiers: [[4, 0.20], [3, 0.15], [2, 0.10]], // số áo → % giảm (chỉ trên áo, tag bundle:apparel)
    offerSwitch: [12, 7],     // tới hết 6/12 mời ornament; từ 7/12 mời cốc (ship kịp Noel)
    christmasCutoff: [12, 7], // "Order by Dec 7 for Christmas"
    feePct: 0.0549, feeFixed: 0.49, // PayPal 3,49% + $0,49 + Shopify Basic 2% (không có Shopify Payments)
    oldAov: 43.28, targetAov: 50,
  };
  var ROUND_OK = ['single-ornament-v1', 'badge-round-v1', 'record-label-v1'];
  var CROSS = ['mug', 'ornament', 'sign', 'canvas'];
  // 26/10 (anh chê "làm như giỡn chơi"): ô "Same design" = MỌI phôi upsell có SP + ảnh, vẽ ĐÚNG thiết kế khách (không đổi layout).
  var FAMS = ['mug', 'glass', 'ornament', 'canvas', 'blanket', 'speaker', 'phone', 'plaque'];
  var NAMES = { mug: 'Matching Mug', glass: 'Whiskey Glass', ornament: 'Glass Ornament', canvas: 'Canvas Print', blanket: 'Sherpa Blanket',
    speaker: 'Bluetooth Speaker', phone: 'Phone Case', plaque: 'Acrylic Plaque', sign: 'Wood Sign', apparel: 'Shirt' };
  var MIN_CONTRAST = 3;   // chữ chính trên nền phôi (WCAG ≥ 3:1)

  function clone(o) { return JSON.parse(JSON.stringify(o)); }
  function round2(v) { return Math.round(v * 100) / 100; }

  /** Khổ vẽ theo họ phôi: cốc dùng chế độ "mặt trước" của core (plan.sheet), print_area_px của bases.json ghi đè w/h.
   *  fmt = khoá FORMATS để mượn (vd 'mug_front' cho ảnh 1 mặt cốc), family = họ phôi thật (căn dọc theo họ). */
  function areaFor(family, printArea, fmt) {
    var F = TMF.FORMATS, f = F[fmt || family] || F.apparel, a = {};
    for (var k in f) if (f.hasOwnProperty(k)) a[k] = f[k];
    // 26/10: căn dọc theo họ phôi (TMF.vAlignOf) — họ không có trong FORMATS (ly, plaque, sherpa…) mượn khổ áo nhưng KHÔNG mượn 'top'
    a.family = family; if (!F[fmt || family]) delete a.valign;
    if (printArea) { a.w = printArea[0]; a.h = printArea[1]; }
    return a;
  }

  /** Thiết kế Vintage Color (màu kem/vàng đồng cố định, không theo mực). */
  function isVintage(d) { return !!(d && (d.fixed_colors || d.skin === 'vintage')); }
  /** Màu CHỮ CHÍNH của thiết kế (để kiểm tương phản): Vintage = kem; Classic = ink_text || ink. */
  function textHex(design, cfg) {
    if (isVintage(design)) return (TMF.VINTAGE_COLORS || {}).cream || '#E5CEA2';
    return TMF.inkHex((cfg && (cfg.ink_text || cfg.ink)) || 'white');
  }
  function contrast(a, b) { return TMF.contrastRatio(a, b); }

  /** Bản Classic White của 1 design Vintage, tra cặp Style trong tmf-designs.json ({designs, styles}). */
  function classicFromDb(db) {
    return function (design) {
      if (!db || !db.styles || !design) return null;
      for (var k in db.styles) {
        if (!db.styles.hasOwnProperty(k)) continue;
        var st = db.styles[k] || [], hit = st.some(function (t) { return t.design === design.id; });
        if (!hit) continue;
        for (var i = 0; i < st.length; i++) {
          var d = db.designs && db.designs[st[i].design];
          if (d && !isVintage(d)) return d;
        }
      }
      return null;
    };
  }

  /**
   * Ảnh nền (tile của tmf-media.json) cho 1 phôi. Cốc: nền đen/trắng THEO MỰC (giữ mực khách — Vintage/mực sáng → cốc đen,
   * mực tối → cốc trắng). Loa: theo tên biến thể (Mini 3W / 6W, Black / White). Trả khoá tile.
   */
  function tileKey(family, design, cfg, variantTitle, tiles) {
    tiles = tiles || {};
    var vt = String(variantTitle || '').toLowerCase(), has = function (k) { return !!tiles[k]; };
    if (family === 'mug') {
      if (/black/.test(vt) && has('mug')) return 'mug';
      if (/white/.test(vt) && has('mug-white')) return 'mug-white';
      if (!has('mug-white')) return 'mug';
      var tx = textHex(design, cfg);
      return isVintage(design) || contrast(tx, (tiles.mug || {}).bgHex || '#151515') >= contrast(tx, (tiles['mug-white'] || {}).bgHex || '#F2F2F2') ? 'mug' : 'mug-white';
    }
    if (family === 'speaker') {
      var k = (/6w/.test(vt) ? 'speaker6' : 'speaker') + (/white/.test(vt) ? '-white' : '');
      return has(k) ? k : 'speaker';
    }
    return family;
  }

  /**
   * Mực cho phôi (Classic): giữ mực khách khi chữ chính đạt ≥ 3:1 trên nền và hình đọc được (inkCheck);
   * không thì mực tương phản nhất theo nền (nền tối: trắng → kem → vàng; nền sáng: đen → xanh → đỏ).
   */
  function inkForBase(cfg, design, bgHex) {
    var T = TMF, out = {}, bg = bgHex || '#151515';
    var okText = function (k) { return k && T.inkKey(k) && contrast(T.inkHex(k), bg) >= MIN_CONTRAST; };
    var okArt = function (k) { return k && T.inkKey(k) && T.inkCheck(k, bg).ok; };
    var dark = contrast('#FFFFFF', bg) >= contrast('#111111', bg);
    var pool = dark ? ['white', 'cream', 'gold', 'silver'] : ['black', 'royal', 'red'];
    var main = cfg.ink_text || cfg.ink;
    if (okArt(cfg.ink) && (cfg.ink_text ? okText(cfg.ink_text) : okText(cfg.ink))) {
      out.ink = cfg.ink;
      if (cfg.ink_text && cfg.ink_text !== cfg.ink) out.ink_text = cfg.ink_text;
      return out;
    }
    if (okText(main) && okArt(main)) { out.ink = main; return out; }
    for (var i = 0; i < pool.length; i++) if (okText(pool[i]) && okArt(pool[i])) { out.ink = pool[i]; return out; }
    out.ink = dark ? 'white' : 'black';
    return out;
  }

  /**
   * CÙNG thiết kế sang phôi khác (26/10: luôn đúng layout + _cfg của khách, KHÔNG thay bằng bản ornament/single).
   * ctx = {lib, classicOf(design) | db, bgHex (nền phôi), tiles (tmf-media.json tiles), variantTitle}
   * Chỉ đổi khi cần cho đọc được trên nền phôi:
   *   - Vintage Color: giữ nguyên nếu chữ kem đạt ≥ 3:1 trên nền (phôi tối: cốc đen, ornament kính trước cây thông);
   *     nền sáng (canvas, sherpa, ly, loa, ốp) → bản Classic White cùng layout (vật màu → vật trắng cùng dáng), mực đen.
   *   - Classic: giữ mực khách nếu chữ chính ≥ 3:1, không thì mực tương phản (inkForBase).
   *   - Cốc: giữ mực khách, chọn cốc đen/trắng theo mực (tileKey).
   * Trả {design, cfg, mode:'same', tile, bgHex, contrast}.
   */
  function crossCfg(cfg, design, family, ctx) {
    ctx = ctx || {};
    var T = TMF, d = T.normalizeDesign(design), c = clone(cfg), dd = d;
    var tiles = ctx.tiles || null, tile = tiles ? tileKey(family, d, cfg, ctx.variantTitle, tiles) : family;
    var bg = (tiles && tiles[tile] && tiles[tile].bgHex) || ctx.bgHex || '#151515';
    var classicOf = ctx.classicOf || (ctx.db ? classicFromDb(ctx.db) : null);
    var twin = function (id) { var L = ctx.lib, it = L && L.get(id); if (!it) return id; if (it.white && L.get(it.white)) return it.white; var w = /^c-/.test(id) && id.slice(2); return w && L.get(w) ? w : id; }; // bản màu thư viện sếp: c-<id trắng>
    if (isVintage(d) && family !== 'apparel' && contrast(textHex(d, c), bg) < MIN_CONTRAST) {
      var cl = classicOf ? classicOf(design) : null;
      if (cl) {
        dd = d = T.normalizeDesign(cl); c.d = d.id; c.layout = d.layout;
        c.items = (c.items || []).map(function (id) { return id ? twin(id) : id; });
        delete c.style; c.ink = 'black'; delete c.ink_text;
      }
    }
    if (family !== 'apparel') delete c.color; // 26/10: màu áo chỉ thuộc dòng áo
    if (family !== 'mug') delete c.mug;       // "Mug print: wrap" chỉ thuộc cốc
    if (!isVintage(d)) {
      var ik = inkForBase(c, dd, bg);
      c.ink = ik.ink; if (ik.ink_text) c.ink_text = ik.ink_text; else delete c.ink_text;
    }
    delete c.edge;
    return { design: dd, cfg: c, mode: 'same', tile: tile, bgHex: bg, contrast: Math.round(contrast(textHex(dd, c), bg) * 100) / 100 };
  }

  /** plan cho 1 họ phôi; lỗi (layout không vẽ được khổ đó) → null. tile (tmf-media.json) → khổ của ảnh nền (fmt/area). */
  function planFor(cfg, design, lib, family, printArea, tile) {
    var pa = printArea || (tile && tile.area) || null, fmt = tile && tile.fmt;
    try { return TMF.plan(cfg, design, lib, areaFor(family, pa, fmt)); } catch (e) { return null; }
  }

  /** Nạp SVG còn thiếu của plan rồi gọi lại cb (1 lần). */
  function ensureShapes(lib, p, cb) {
    var need = TMF.shapeIds(p).filter(function (id) { return lib.get(id) && !lib.has(id); });
    if (!need.length) return false;
    lib.ensure(need, function (f) { return fetch(lib.urlOf ? lib.urlOf(f) : f).then(function (r) { return r.text(); }); }).then(cb).catch(function () {}); // theme: tên file → URL asset (assetBase + ?v=)
    return true;
  }

  /**
   * Vẽ 1 ô: nền phôi (ảnh thật hoặc hàm vẽ code) + thiết kế trong vùng in.
   * o = {W, H (hệ toạ độ nền), image (HTMLImageElement đã nạp) | paint(ctx), box {x,y,w,h} (toạ độ nền), circle (bool),
   *      plan, lib, cfg, opacity, cache, over (HTMLImageElement: lớp che vẽ SAU thiết kế, vd dây mũ hoodie — 26/10 tối)}
   */
  function drawTile(cv, cssW, o) {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = o.W, H = o.H;
    var pw = Math.max(1, Math.round(cssW * dpr)), ph = Math.max(1, Math.round(cssW * dpr * H / W));
    if (cv.width !== pw) cv.width = pw;
    if (cv.height !== ph) cv.height = ph;
    var ctx = cv.getContext('2d'), k = cv.width / W;
    ctx.setTransform(k, 0, 0, k, 0, 0);
    ctx.fillStyle = o.bg || '#ece8e1'; ctx.fillRect(0, 0, W, H);
    if (o.image && o.image.complete && o.image.naturalWidth) ctx.drawImage(o.image, 0, 0, W, H);
    else if (o.paint) o.paint(ctx);
    var p = o.plan;
    if (!p) return;
    var box = o.box, sc = Math.min(box.w / p.w, box.h / p.h);
    var ox = box.x + (box.w - p.w * sc) / 2, oy = box.y + (box.h - p.h * sc) / 2;
    ctx.save();
    if (o.circle) { ctx.beginPath(); ctx.arc(box.x + box.w / 2, box.y + box.h / 2, Math.min(box.w, box.h) / 2, 0, Math.PI * 2); ctx.clip(); }
    ctx.globalAlpha = o.opacity || 0.94;
    var io = TMF.inkOpts(o.cfg || {});
    TMF.draw(ctx, p, o.lib, { ink: io.ink, inkText: io.inkText, scale: sc, x: ox, y: oy, cache: o.cache || (drawTile._c || (drawTile._c = {})) });
    ctx.restore();
    var ov = o.over;
    if (ov && ov.complete && ov.naturalWidth && o.image && o.image.complete && o.image.naturalWidth) ctx.drawImage(ov, 0, 0, W, H);
  }

  /**
   * Luật giỏ. lines = [{kind:'apparel'|'mug'|'ornament'|'sign'|'canvas'|'addon', price, qty?}]
   * Trả {items, apparelQty, subtotal, discPct, disc, goodsAfter, ship, freeShip, total, needItems, progress, msg}
   */
  function totals(lines, rules) {
    rules = rules || RULES;
    var items = 0, appQty = 0, appSum = 0, sub = 0;
    lines.forEach(function (l) {
      var q = l.qty || 1;
      sub += l.price * q;
      if (l.kind !== 'addon') items += q;
      if (l.kind === 'apparel') { appQty += q; appSum += l.price * q; }
    });
    var pct = 0;
    for (var i = 0; i < rules.apparelTiers.length; i++) if (appQty >= rules.apparelTiers[i][0]) { pct = rules.apparelTiers[i][1]; break; }
    var disc = round2(appSum * pct), after = round2(sub - disc);
    var free = items >= rules.freeShipMinItems || (items === 1 && after >= rules.freeShipMinSubtotal);
    var ship = items === 0 || free ? 0 : rules.shipFee;
    var need = free || items === 0 ? 0 : rules.freeShipMinItems - items;
    var msg = items === 0 ? 'FREE US shipping on 2+ items'
      : free ? 'You’ve unlocked FREE US shipping'
      : 'Add ' + need + ' more item' + (need > 1 ? 's' : '') + ' for FREE US shipping';
    return {
      items: items, apparelQty: appQty, apparelSum: round2(appSum), subtotal: round2(sub), discPct: pct, disc: disc,
      goodsAfter: after, ship: ship, freeShip: free && items > 0, total: round2(after + ship), needItems: need,
      progress: items === 0 ? 0 : free ? 1 : Math.min(0.95, items / rules.freeShipMinItems), msg: msg,
      nextTier: nextTier(appQty, rules),
    };
  }
  function nextTier(q, rules) {
    var t = rules.apparelTiers.slice().sort(function (a, b) { return a[0] - b[0]; });
    for (var i = 0; i < t.length; i++) if (q < t[i][0]) return { qty: t[i][0], pct: t[i][1] };
    return null;
  }

  function beforeMD(today, md) { var m = today.getMonth() + 1, d = today.getDate(); return m < md[0] || (m === md[0] && d < md[1]); }

  /** ĐÚNG 1 lời mời: chưa có món thứ 2 → ornament (trước 7/12) / cốc; đã 2+ món → áo cho bạn cùng ban (nếu có áo trong giỏ). */
  function pickOffer(lines, today, rules) {
    rules = rules || RULES; today = today || new Date();
    var phys = lines.filter(function (l) { return l.kind !== 'addon'; });
    if (!phys.length) return null;
    var has = function (k) { return phys.some(function (l) { return l.kind === k; }); };
    var src = phys.filter(function (l) { return l.kind === 'apparel'; })[0] || phys[0];
    if (phys.length < rules.freeShipMinItems) {
      var kind = beforeMD(today, rules.offerSwitch) ? 'ornament' : 'mug';
      if (has(kind)) kind = kind === 'ornament' ? 'mug' : 'ornament';
      return { type: kind, source: src, unlocksShip: true };
    }
    if (src.kind === 'apparel') return { type: 'bandmate', source: src };
    return null;
  }

  function addBizDays(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; }
    return x;
  }
  /** Ngày giao ước tính: sản xuất (ngày làm việc) + ship US 3–5 ngày làm việc. */
  function deliveryEstimate(today, priority) {
    today = today || new Date();
    var prod = priority ? [1, 1] : [1, 3], ship = [3, 5];
    return { from: addBizDays(today, prod[0] + ship[0]), to: addBizDays(today, prod[1] + ship[1]) };
  }
  function fmtDate(d) { return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][d.getMonth()] + ' ' + d.getDate(); }
  function christmasOk(today, rules) { return beforeMD(today || new Date(), (rules || RULES).christmasCutoff); }

  /** Lời nhắn thiệp: chữ Latin cơ bản + dấu câu thường, nháy cong → thẳng, bỏ emoji/HTML, ≤ 150 ký tự, ≤ 4 dòng. */
  function cleanNote(s, max) {
    max = max || 150;
    var t = String(s || '').replace(/[‘’ʼ]/g, "'").replace(/[“”]/g, '"').replace(/[–—]/g, '-').replace(/\r/g, '').replace(/<[^>]*>/g, '');
    t = t.replace(/[^A-Za-z0-9 .,!?'"&:;()\-\n]/g, '');
    t = t.replace(/ {2,}/g, ' ').replace(/\n{2,}/g, '\n');
    var parts = t.split('\n'); if (parts.length > 4) t = parts.slice(0, 4).join('\n') + ' ' + parts.slice(4).join(' ');
    return t.slice(0, max);
  }

  /**
   * Lãi ước 1 đơn. lines có cost (vốn món = base + ship kiện đầu + phụ phí lễ) và saveShip (= ship kiện đầu − ship kiện thêm).
   * "xau" = mọi món tính ship kiện đầu; "tot" = món đắt nhất giữ ship kiện đầu, món khác ship kiện thêm.
   */
  function profit(lines, tot, rules) {
    rules = rules || RULES;
    var cost = 0, phys = [];
    lines.forEach(function (l) { cost += (l.cost || 0) * (l.qty || 1); if (l.kind !== 'addon') phys.push(l); });
    var save = 0;
    if (phys.length > 1) phys.slice().sort(function (a, b) { return a.cost - b.cost; }).slice(0, -1).forEach(function (l) { save += l.saveShip || 0; });
    var fee = tot.total > 0 ? tot.total * rules.feePct + rules.feeFixed : 0;
    return { revenue: tot.total, cost: round2(cost), costGood: round2(cost - save), fee: round2(fee), bad: round2(tot.total - cost - fee), good: round2(tot.total - cost + save - fee) };
  }

  return {
    FAMS: FAMS, NAMES: NAMES, MIN_CONTRAST: MIN_CONTRAST, tileKey: tileKey, classicFromDb: classicFromDb, textHex: textHex, isVintage: isVintage,
    RULES: RULES, ROUND_OK: ROUND_OK, CROSS: CROSS, areaFor: areaFor, inkForBase: inkForBase, crossCfg: crossCfg, planFor: planFor,
    ensureShapes: ensureShapes, drawTile: drawTile, totals: totals, pickOffer: pickOffer, deliveryEstimate: deliveryEstimate,
    fmtDate: fmtDate, christmasOk: christmasOk, beforeMD: beforeMD, cleanNote: cleanNote, profit: profit,
  };
});
